/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";

const FIELD_TO_PARAM = {
  "survey.name": "surveyname",
  customreserveid: "customreserveid",
  user: "user",
  surveyresponse: "surveyresponse",
  surveydate: "surveydate",
};

// MaterialReactTable
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { postData, getData, putData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { Link, useParams } from "react-router-dom";

const FeedbackResponseList = ({
  downloadExcel,
  search,
  checkedRecordCount,
  setRecords,
}) => {
  const token = localStorage.getItem("token"); // to get the token

  const params = useParams();

  const {
    setEditSurveyData,
    screenHeight,
    setReloadFeedbackResponse,
    reloadFeedbackResponse,
  } = useContext(GlobalProvider);

  /* hook to get feedback response data */
  const [feedbackResponseData, setFeedbackResponseData] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return feedbackResponseData.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : feedbackResponseData;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Feedback Responses.xlsx");
  };

  const { t } = useTranslation(); //for translation

  // console.log(`editSurveyData=============>>>`, editSurveyData);

  //function for get feedback responses
  const getAllFeedBackResponse = async (currentColumnFilters = columnFilters) => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_SURVEY_FEEDBACK +
        `?token=${token}&surveyid=${params.id}`;

      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });

      console.log("feedback list url =====>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log("feedback responses list response ========>>>", response);

      if (response.data) {
        setFeedbackResponseData(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* ---------- custom name html  ---------------- */
  const surveyNameHtml = ({ dataItem }) => {
    return (
      <div className="kendoCustomColumn overflow-visible">
        <div className="d-flex align-items-center">
          <p>{dataItem.survey.name}</p>
          <Link
            to="#view_all_survey_feedback_popup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
            onClick={() => setEditSurveyData(dataItem)}
          >
            <span className="material-icons-outlined">chevron_right</span>
          </Link>
        </div>
      </div>
    );
  };

  //custom html for status
  const statusHTML = ({ dataItem }) => {
    return (
      <div>
        <span>{dataItem.surveyresponse}</span>
      </div>
    );
  };

  // Helper function to format date
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const pad = (n) => n.toString().padStart(2, "0");
    return `${pad(date.getUTCDate())}/${pad(date.getUTCMonth() + 1)}/${pad(
      date.getUTCFullYear()
    )} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
  };

  // Custom cell for createdAt
  const createdAtCell = ({ dataItem }) => (
    <div>{formatDateTime(dataItem.createdAt)}</div>
  );

  // Column definitions
  const tableColumns = useMemo(() => [
    {
      id: "survey.name",
      accessorFn: (row) => row.survey?.name ?? "",
      header: t("Survey"),
      Cell: ({ row }) => surveyNameHtml({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "customreserveid",
      accessorKey: "customreserveid",
      header: t("Reservation ID"),
      size: 200,
    },
    {
      id: "user",
      accessorKey: "user",
      header: t("User"),
      size: 200,
    },
    {
      id: "user.role.name",
      accessorFn: (row) => row.user?.role?.name ?? "",
      header: t("Label"),
      size: 200,
    },
    {
      id: "surveyresponse",
      accessorKey: "surveyresponse",
      header: t("Status"),
      Cell: ({ row }) => statusHTML({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "createdAt",
      accessorKey: "createdAt",
      header: t("Request Date"),
      Cell: ({ row }) => createdAtCell({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "surveydate",
      accessorKey: "surveydate",
      header: t("Response Date"),
      size: 200,
    },
  ], [feedbackResponseData]);

  useEffect(() => {
    if (reloadFeedbackResponse) {
      getAllFeedBackResponse();
      setReloadFeedbackResponse(false);
    }
  }, [reloadFeedbackResponse]);

  /* hook to hit exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  useEffect(() => {
    getAllFeedBackResponse();
  }, [params.id]);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllFeedBackResponse(columnFilters);
    }, 500);
  }, [columnFilters]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, feedbackResponseData]);

  return (
    <div className="table-responsive">
      {/* ------------------- grid view start -------------------- */}
      <MaterialReactTable
        columns={tableColumns}
        data={feedbackResponseData}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        manualFiltering
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight - 50 } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
      {/* ------------------- grid view end -------------------- */}
    </div>
  );
};

export default FeedbackResponseList;
